
import { Link, useLocation } from "react-router-dom";
import { LogOut, LogIn, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";

interface AuthActionsProps {
  isAuthenticated: boolean;
  onLogout: () => Promise<void>;
  loading: boolean;
  onHero?: boolean;
}

export const AuthActions = ({ isAuthenticated, onLogout, loading, onHero = false }: AuthActionsProps) => {
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              asChild
              className={onHero ? "text-white hover:bg-white/10" : "text-black hover:bg-black/10"}
            >
              <Link to="/signin" aria-label="Log in">
                <LogIn className="h-5 w-5" aria-hidden="true" />
              </Link>
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Log In</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <>
      {/* Desktop only settings button */}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              asChild
              className={`hidden md:inline-flex ${onHero ? "text-white hover:bg-white/10" : "text-black hover:bg-black/10"} ${
                location.pathname === '/profile' ? (onHero ? 'bg-white/10' : 'bg-black/10') : ''
              }`}
            >
              <Link to="/profile" aria-label="Settings">
                <Settings className="h-5 w-5" aria-hidden="true" />
              </Link>
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Settings</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      
      {/* Logout button (both mobile and desktop) */}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button 
              variant="ghost" 
              size="icon" 
              onClick={onLogout}
              disabled={loading}
              aria-label="Log out"
              className={onHero ? "text-white hover:bg-white/10" : "text-black hover:bg-black/10"}
            >
              <LogOut className="h-5 w-5" aria-hidden="true" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Log Out</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </>
  );
};
